<template>
  <v-main>
    <home-banner></home-banner>
    <home-menu></home-menu>
    <v-container>
      <h2 class="ml-4 mt-4">
        最新消息
      </h2>
      <v-divider class="my-4"></v-divider>
      <app-load v-if="load"></app-load>
      <article-previewing
        v-for="(article, idx) in articles"
        :key="idx"
        :article="article"
        :index="idx"
      ></article-previewing>
    </v-container>
  </v-main>
</template>

<script>
import apiArticle from '@/assets/js/db/api/article';

export default {
  name: 'Home',
  data: () => ({
    load: true,
    articles: []
  }),
  components: {
    'home-banner': () => import('../components/home/banner'),
    'home-menu': () => import('../components/home/menu'),
    'article-previewing': () => import('../components/article/previewing'),
    'app-load': () => import('../components/app/load')
  },
  computed: {
    mobile() {
      return this.$store.state.mobile;
    }
  },
  mounted() {
    this.initArticle();
  },
  methods: {
    async initArticle() {
      this.load = true;
      await this.getArticle();
      this.load = false;
    },
    async getArticle() {
      await apiArticle.getList({})
        .then(({ data }) => {
          this.articles = data;
        })
        .catch(err => {
          console.log(err);
          this.articles = [];
        });
    }
  }
}
</script>
